module.exports = __webpack_public_path__ + "fonts/0ab29c89ca8e76a9c5a23079178f7b24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_green.svg
// module id = 2009
// module chunks = 0